/**
 * PLG OS Frontend Tracking
 *
 * ⚠️ LOCAL/MOCK MODE: This module currently logs events to the browser console only.
 *
 * This is intentional for the current development phase. Real PLG OS tracking
 * requires a server-side integration to avoid exposing API keys in the frontend.
 *
 * Server-side tracking is implemented in src/server/plgServerTracking.js and
 * is the recommended production path for critical onboarding events.
 *
 * When a real client-side PLG OS SDK becomes available:
 * 1. Configure the SDK with environment-safe initialization
 * 2. Replace console.log with actual SDK calls
 * 3. Ensure the SDK does not expose server-side secrets
 */

/**
 * Logs a tracking event to the browser console.
 * This is a mock/development implementation only.
 *
 * @param {string} eventName - The name of the event to track
 * @param {Object} payload - Additional event properties
 */
export const trackEvent = (eventName, payload = {}) => {
  const timestamp = new Date().toISOString();
  
  // 🏷️ Clearly labeled as local-only tracking
  console.log(
    `[PLG OS FRONTEND - MOCK MODE] Event: "${eventName}" at ${timestamp}`,
    {
      ...payload,
      _meta: {
        mode: 'mock',
        source: 'browser-console',
        note: 'Not sent to PLG OS - use server tracking for production analytics'
      }
    }
  );
};

/**
 * Standard event names used throughout the onboarding flow.
 * These should be kept in sync with server-side tracking events.
 */
export const EVENTS = {
  STARTED: 'onboarding_started',
  STEP_1_COMPLETED: 'business_info_completed',
  STEP_2_COMPLETED: 'review_goals_completed',
  STEP_3_COMPLETED: 'integration_setup_completed',
  COMPLETED: 'onboarding_completed',
  // Additional frontend-specific events can be added here
  FORM_FIELD_INTERACTION: 'form_field_interaction',
  VALIDATION_ERROR: 'validation_error',
  NAVIGATION_BACK: 'navigation_back'
};